const ThridText = ({contact, color, background, link, url, supple=""}) => {
    if (link) {
        return (
            <span style={{color: color, background: background, overflowWrap: 'break-word'}}>
                <a href={url + contact + supple} style={{color: color}} target="_blank" rel="noreferrer">{contact}</a>
            </span>
        )
    } else {
        return (
            <span style={{color: color, background: background, overflowWrap: 'break-word'}}>
                {contact}
            </span>
        )
    }
}

export default ThridText
